// Configuration for platform URLs
// These can be overridden by environment variables

// Default URLs for production
const DEFAULT_DASHBOARD_URL = 'https://app.jua.ai';

// Environment variables from Vite (defined in .env files or at build time)
export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || DEFAULT_DASHBOARD_URL;

// Helper function to determine if we're using local development URLs
export const isUsingLocalDevelopment = (): boolean => {
  return DASHBOARD_URL.includes('localhost') || DASHBOARD_URL.includes('127.0.0.1');
};

// Export a function to get the dashboard URL with optional path
export const getDashboardUrl = (path: string = ''): string => {
  return `${DASHBOARD_URL}${path}`;
};
